const INITIAL_STATE = {
  callingDatabaseService: false
};

export const databaseServiceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CALL_DATABASE_SERVICE":
      return {
        ...state,
        callingDatabaseService: true
      };

    case "DATABASE_SERVICE_CALL_ENDED":
      return {
        ...state,
        callingDatabaseService: false
      };

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/Maintenance/databaseServiceReducer.js